var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"rowSelection":_vm.rowSelection,"columns":_vm.columns,"dataSource":_vm.data},scopedSlots:_vm._u([{key:"name",fn:function(text){return _c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(text))])}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }